const COMPLETE_REGISTRATION = 'CompleteRegistration';
const TWITTER_CONVERSION_OBJECT = { tw_sale_amount: 0, tw_order_quantity: 0 };

export { COMPLETE_REGISTRATION, TWITTER_CONVERSION_OBJECT };
